import { useState, useEffect } from 'react';
import { adminProductsAPI } from './adminApi';
import s from './AdminProducts.module.css';

const CATS = ['','electronics','fashion','home','beauty','sports','gaming','computing','supermarket','foodstuff','deals'];

export default function AdminProducts() {
  const [products, setProducts] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [search,   setSearch]   = useState('');
  const [category, setCategory] = useState('');
  const [acting,   setActing]   = useState(null);

  const load = () => {
    setLoading(true);
    adminProductsAPI.list({ q: search, category, per_page: 50 })
      .then(res => setProducts(res.data.products || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, [search, category]);

  const toggle = async (id, current) => {
    setActing(id);
    try {
      await adminProductsAPI.toggle(id, !current);
      setProducts(prev => prev.map(p => p.id === id ? { ...p, isActive: !current } : p));
    } catch { alert('Failed'); }
    finally { setActing(null); }
  };

  const del = async (id) => {
    if (!window.confirm('Delete this product? Cannot be undone.')) return;
    setActing(id);
    try {
      await adminProductsAPI.delete(id);
      setProducts(prev => prev.filter(p => p.id !== id));
    } catch { alert('Failed'); }
    finally { setActing(null); }
  };

  return (
    <div className={s.page}>
      <div className={s.header}>
        <h1 className={s.title}>Products</h1>
        <p className={s.sub}>{products.length} products loaded</p>
      </div>

      <div className={s.toolbar}>
        <input className={s.search} placeholder="Search products…" value={search} onChange={e => setSearch(e.target.value)} />
        <select className={s.select} value={category} onChange={e => setCategory(e.target.value)}>
          {CATS.map(c => <option key={c} value={c}>{c ? c.charAt(0).toUpperCase() + c.slice(1) : 'All categories'}</option>)}
        </select>
      </div>

      {loading ? (
        <div className={s.loading}><div className={s.spin} /></div>
      ) : (
        <div className={s.table}>
          <div className={s.thead}>
            <span>Product</span><span>Category</span><span>Code</span><span>Price</span><span>Stock</span><span>Status</span><span>Actions</span>
          </div>
          {products.length === 0 && <p className={s.empty}>No products found</p>}
          {products.map(p => (
            <div key={p.id} className={s.trow}>
              <div className={s.pcell}>
                {p.image ? <img src={p.image} alt={p.name} className={s.pimg} /> : <div className={s.pimgph}>📦</div>}
                <span className={s.pname}>{p.name}</span>
              </div>
              <span className={s.cell}>{p.category}</span>
              <span className={`${s.cell} ${s.code}`}>{p.productCode || `#${p.id}`}</span>
              <span className={s.cell}>₦{Number(p.price).toLocaleString()}</span>
              <span className={s.cell}>{p.stock}</span>
              <span className={s.cell}>
                <span className={s.dot} style={{ background: p.isActive ? '#10B981' : '#EF4444' }} />
                {p.isActive ? 'Live' : 'Hidden'}
              </span>
              <div className={s.actions}>
                <button className={`${s.btn} ${p.isActive ? s.hideBtn : s.showBtn}`} onClick={() => toggle(p.id, p.isActive)} disabled={acting === p.id}>
                  {p.isActive ? 'Hide' : 'Show'}
                </button>
                <button className={`${s.btn} ${s.deleteBtn}`} onClick={() => del(p.id)} disabled={acting === p.id}>Del</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
